import script from "./Marquee.vue?vue&type=script&setup=true&lang=ts"
export * from "./Marquee.vue?vue&type=script&setup=true&lang=ts"

import "./Marquee.vue?vue&type=style&index=0&id=519ed560&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519ed560"]])

export default __exports__